module.exports = __webpack_public_path__ + "img/parlient.68572628.jpg";